import { useContext, useState } from "react"
import { rootContext } from "../../contexts/rootContext"
import Grid from "@mui/material/Grid2";
import { FormControlLabel, Checkbox, Button } from "@mui/material";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { getContrastingTextColor } from "../../utilities/colorHelper"

interface WarningProps {
    onAcknowledge: () => void
}

export const Warning = (props: WarningProps) => {
    const context = useContext(rootContext)

    return (<Grid container spacing={4}>
        <Grid>Water levels shown are estimates derived from USGS gauge data and interpolation models. Conditions may differ substantially from actual river conditions. This application is provided for informational purposes only and should not be relied upon as the sole basis for safety or trip-planning decisions.</Grid>
        <Grid>River conditions can change rapidly due to rainfall, dam operations, debris, or sensor inaccuracies. Estimated water levels may be incorrect. Always use your own judgment and verify conditions before entering the river.</Grid>
        <Grid 
            container 
            size={12} 
            justifyContent="flex-end"
        >
            <Button
                variant="contained"
                onClick={props.onAcknowledge}
                sx={{
                    backgroundColor: context.theme.text.contrast4,
                    color: getContrastingTextColor(context.theme.text.contrast4),
                    "&:hover": { backgroundColor: context.theme.text.contrast4, opacity: 0.85 }
                }}
            >
                Acknowledge
            </Button>
        </Grid>
    </Grid>)
}